import {
  useMutation,
  UseMutationResult,
  UseMutationOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import { WaitlistDto, ResponseDto, JoinWaitlistDto } from "@mimber/schema"

/**
 * Organization-specific hook for joining the waitlist
 * Can only be used in mimber-organization app
 * Uses unauthenticatedServer since the waitlist endpoint is public
 */
export const useJoinWaitlist = (
  options?: UseMutationOptions<ResponseDto<WaitlistDto>, Error, JoinWaitlistDto>
): UseMutationResult<ResponseDto<WaitlistDto>, Error, JoinWaitlistDto> => {
  guardAppUsage("mimber-organization", "useJoinWaitlist")

  const { unauthenticatedServer } = useServerContext()

  return useMutation({
    ...options,
    mutationFn: async (params: JoinWaitlistDto) => {
      const response = await unauthenticatedServer.post<
        ResponseDto<WaitlistDto>
      >("waitlist", params)
      return response.data
    },
    onSuccess: (data, variables, onMutateResult, context) => {
      options?.onSuccess?.(data, variables, onMutateResult, context)
    },
  })
}
